import { CommonModule } from '@angular/common';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { VideoThumbnailComponent } from '../video-thumbnail/video-thumbnail.component';
import { VideoSearchResult } from '../../model/video-search-result.model';
import { Router } from '@angular/router';
import { VideoMetadataComponent } from "../video-metadata/video-metadata.component";
import { AdminDataService } from 'src/app/features/admin/controller/admin-data.service';
import { ConfirmationModalComponent } from 'src/app/fragments/confirmation-modal/confirmation-modal.component';
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-video-card',
  templateUrl: './video-card.component.html',
  styleUrls: ['./video-card.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    VideoThumbnailComponent,
    VideoMetadataComponent
]
})
export class VideoCardComponent implements OnInit {

  @Input() video: VideoSearchResult = null;
  @Input() isInternalUser: boolean = false; // Solo true si es @iasolver
  @Output() videoDeleted = new EventEmitter<void>();

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private adminDataService: AdminDataService,
  ) { }

  ngOnInit(): void {
  }

  onDeleteClick(event: MouseEvent): void {
    event.stopPropagation(); // IMPORTANTE: Evita entrar al video al hacer click en borrar

    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      data: {
        title: '⚠️ ZONA PELIGROSA: Borrado Completo',
        message: `Vas a eliminar el video "${this.video.title}".\n\nEsta acción borrará:\n- Estadísticas y Eventos\n- Cortes y Scouting\n- Configuración de Equipos\n\nLos archivos en S3 se mantendrán pero quedarán desvinculados.\n¿Estás seguro?`,
        confirmText: 'ELIMINAR DEFINITIVAMENTE',
        cancelText: 'Cancelar'
      }
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.executeDelete();
      }
    });
  }

  private executeDelete(): void {
    this.adminDataService.deleteVideo(this.video.id).subscribe({
      next: () => {
        this.snackBar.open('Video eliminado correctamente', 'Cerrar', { duration: 3000 });
        this.videoDeleted.emit(); // Notificamos al padre para refrescar la lista
      },
      error: (err) => {
        console.error('Error deleting video:', err);
        this.snackBar.open('Error al eliminar el video. Revisa la consola.', 'Cerrar', { duration: 3000 });
      }
    });
  }

  isLoading(): boolean {
    return !this.video;
  }

  onVideoClick(video: VideoSearchResult) {
    const videoId = video.id;

    this.router.navigate(['/watch', videoId],
      {
        state: { video },
      }
    );
  }

  getFormatedVideoDuration(): string {

    let videoDurationInSeconds = this.video?.duration_in_seconds;
    let seconds = 0;
    let minutes = 0;
    let hours = 0;
    let durationOutputString = '';


    if (!videoDurationInSeconds) {
      return '0:00';
    }

    videoDurationInSeconds = Math.floor(videoDurationInSeconds);

    // Convert the duration from seconds to a human-readable format
    minutes = Math.floor(videoDurationInSeconds / 60);
    seconds = videoDurationInSeconds % 60;
    hours = Math.floor(minutes / 60);
    minutes = minutes % 60;

    if (hours > 0) {
      durationOutputString += hours + ':';
    }

    if (minutes < 10) {
      durationOutputString += '0';
    }

    durationOutputString += minutes + ':';

    if (seconds < 10) {
      durationOutputString += '0';
    }

    durationOutputString += seconds;

    return durationOutputString;
  }

}
